/* eslint-disable import/prefer-default-export */
import GerepAPI from './GerepApi'

export const login = values => GerepAPI.post('/login', values)
